const useStyles = theme => ({
  mainPlayerContainer: {
    flexGrow: 1,
    display: 'flex',
  },
  mainPlayerVideoTitle: {
    marginLeft: 15,
    marginRight: 15,
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 10,
      marginRight: 10
    }
  },
  mainPlayerVideoDescription: {
    marginTop: 10,
    marginLeft: 15,
    marginRight: 15,
    marginBottom: 25,
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 10,
      marginRight: 10
    }
  },
  mainPlayerTitleBoxRoot: {
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 2,
    wordBreak: "break-word",
    overflow: "hidden",
  },
  mainPlayerDescriptionBoxRoot: {
    display: "-webkit-box",
    boxOrient: "vertical",
    lineClamp: 1,
    wordBreak: "break-word",
    overflow: "hidden",
    [theme.breakpoints.down('md')]: {
      lineClamp: 2,
    }
  },
  voltaxPlayerContainer: {
    marginLeft: 15,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    }
  }
});

export default useStyles
